import api from '@/utils/api';
import { NotificationManager } from 'react-notifications';
import { presentCommissionError } from '@/utils/commission/errorPresenter';
import { FETCH_COMMISSION_POLICIES } from './types';

const fail = error => presentCommissionError(
    error,
    'Không thể xử lý chính sách hoa hồng. Vui lòng kiểm tra dữ liệu và thử lại.',
    { operation: 'POLICY' },
);
const failLoading = error => presentCommissionError(
    error,
    'Không tải được dữ liệu chính sách hoa hồng.',
    { presentation: 'notification' },
);

export const fetchCommissionPolicies = (filters = {}) => dispatch => Promise.all([
    api.get('/commission-policies', { params: filters }),
    api.get('/commission-policies/capabilities'),
]).then(([policies, capabilities]) => {
    const payload = {
        policies: policies.data.data?.data || [],
        pagination: policies.data.data || {},
        capabilities: capabilities.data.data || {},
    };
    dispatch({ type: FETCH_COMMISSION_POLICIES, payload });
    return payload;
}).catch(failLoading);

export const saveCommissionPolicy = (current, values) => () => {
    const request = current ? api.put(`/commission-policies/${current.id}`, {
        ...values, version_id: current.versions?.[0]?.id,
    }) : api.post('/commission-policies', values);
    return request.then(response => {
        NotificationManager.success(current ? 'Đã cập nhật bản nháp.' : 'Đã tạo bản nháp chính sách.');
        return response.data.data;
    }).catch(fail);
};

export const changeCommissionPolicyStatus = (policyId, versionId, status, reason) => () =>
    api.post(`/commission-policies/${policyId}/versions/${versionId}/status`, { status, reason })
        .then(response => { NotificationManager.success('Đã cập nhật trạng thái chính sách.'); return response.data.data; })
        .catch(fail);

export const createCommissionPolicyVersion = (policyId, values = {}) => () =>
    api.post(`/commission-policies/${policyId}/versions`, values)
        .then(response => { NotificationManager.success('Đã tạo phiên bản mới.'); return response.data.data; })
        .catch(fail);

export const fetchCommissionPolicyDetail = policyId => () =>
    api.get(`/commission-policies/${policyId}`).then(response => response.data.data).catch(failLoading);

export const compareCommissionPolicyVersions = (policyId, versionId, compareVersionId) => () =>
    api.get(`/commission-policies/${policyId}/versions/${versionId}/compare/${compareVersionId}`)
        .then(response => response.data.data).catch(failLoading);

export const validateCommissionPolicyVersion = (policyId, versionId) => () =>
    api.post(`/commission-policies/${policyId}/versions/${versionId}/validate`)
        .then(response => {
            const result = response.data.data;
            if (!result.errors?.length && result.warnings?.length) {
                NotificationManager.warning(`Cảnh báo khi kiểm tra chính sách: ${result.warnings.join(' ')} Hãy xử lý cảnh báo trước khi kích hoạt.`);
            } else if (!result.errors?.length) {
                NotificationManager.info('Thông tin: cấu hình chính sách đã đạt kiểm tra và có thể chuyển sang bước kích hoạt.');
            }
            return result;
        }).catch(fail);

export const cloneCommissionPolicy = (policyId, values) => () =>
    api.post(`/commission-policies/${policyId}/clone`, values)
        .then(response => { NotificationManager.success('Đã sao chép thành bản nháp mới.'); return response.data.data; })
        .catch(fail);
